<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

const props = defineProps<{ product: ProductDocument }>();
const badgeLabel = computed(() => {
  if (props.product.pre_order_timestamp) {
    return `Disponible le ${datetime(props.product.pre_order_timestamp)}`;
  }
  if (props.product.pre_order) {
    return "Précommande";
  }
  if (props.product.is_featured) {
    return "Coup de cœur";
  }
  if (props.product.on_sale) {
    return "Solde !";
  }
  return false;
});
</script>

<template>
  <div class="relative flex h-full flex-col text-center">
    <a :href="product.permalink" class=" block transition-transform hover:scale-110">
      <img :src="product.image_url" class="aspect-square w-full object-contain lg:p-8 ">
    </a>
    <div v-if="badgeLabel" class="absolute left-0 top-0 rounded-r-full bg-primary px-2 py-1 text-sm font-bold text-white">
      {{ badgeLabel }}
    </div>
    <div class="text-base font-semibold leading-tight">
      {{ product.name }}
    </div>
    <div class="mt-auto space-y-4">
      <ProductPriceSimple :product="product" />
      <div class="flex items-center justify-center gap-4">
        <ProductAddToCart :product="product" />
        <ProductToggleWishlist :product-id="product.product_id" :show-label="false" />
      </div>
    </div>
  </div>
</template>
